module.exports = __webpack_public_path__ + "media/promo/panasonic/images/test-2f235681c01cf6c66efa8a4321e1609a.jpg";